// extracted by mini-css-extract-plugin
export default {"block":"preview-image__block___oTmAc","imageWrapper":"preview-image__imageWrapper___jGA6o","image":"preview-image__image___olHcm"};